import React, { Component } from 'react';
import { HeatMap } from '$components/projects';
import { Spinner, Translate } from '$common';
import { currentAccountLocations } from '../../api';
import { connect } from "react-redux";
import { changeTitle } from "$actions/root";

@connect(null, { changeTitle })
export default class HeatMapRoute extends Component {
  state = {
    locations: undefined
  };

  async currentAccountLocations() {
    const locations = await currentAccountLocations();
    this.setState({ locations });
  }

  componentWillMount() {
    this.props.changeTitle(Translate.get('heat_map'))
    this.currentAccountLocations();
  }

  render() {
    const { locations } = this.state;

    if (locations !== undefined) {    
      return(
        <HeatMap
          points={locations}
        />
      )
    } else {
      return(
        <Spinner block center fullPage/>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/routes/projects/heat-map.js